module.exports = __webpack_public_path__ + "img/bmbf_logo.34a0d65b.svg";